import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const InboxContainer = React.lazy(() => import('../../containers/inbox/inbox.container'));
const CorporateWhatsappContainer = React.lazy(
  () => import('../../containers/corporate-whatsapp/corporate-whatsapp.container')
);
const ConsumerWhatsappContainer = React.lazy(
  () => import('../../containers/consumer-whatsapp/consumer-whatsapp.container')
);
const ConsumerFacebookContainer = React.lazy(
  () => import('../../containers/consumer-facebook/consumer-facebook.container')
);
const ConsumerInstagramContainer = React.lazy(
  () => import('../../containers/consumer-instagram/consumer-instagram.container')
);

export const CommunicationRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <Navigate to={(APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).INBOX.FULL_PATH} />
    )
  },
  {
    path: (APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).INBOX.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER
          ]}
          component={InboxContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).CONSUMER_WHATSAPP.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER
          ]}
          component={ConsumerWhatsappContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).CONSUMER_FACEBOOK.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER
          ]}
          component={ConsumerFacebookContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).CONSUMER_INSTAGRAM.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER
          ]}
          component={ConsumerInstagramContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.COMMUNICATION_MODULE.CHILDREN as RouteConfig).CORPORATE_WHATSAPP.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[
            UserRole.ADMIN,
            UserRole.SALES_MANAGER,
            UserRole.SALES_AGENT,
            UserRole.SALES_QUALITY_MANAGER,
            UserRole.SALES_QUALITY_AGENT,
            UserRole.E_COMMERCE_MANAGER
          ]}
          component={CorporateWhatsappContainer}
        />
      </React.Suspense>
    )
  }
];
